var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AuthView',{attrs:{"form":_vm.FORM_CONFIG,"formLoading":_vm.loading,"subtitle":_vm.inviteMessage},on:{"submit":_vm.onSubmit}})
}
var staticRenderFns = []

export { render, staticRenderFns }